export default "__VITE_ASSET__CD4BEJUx__"